import { useMemo } from 'react';

import { useSelector } from '../../selectors/useSelector';

import SelectPropertyConstants from '../../constants/SelectPropertyConstants';

import selectPropertyUtils from '../../utils/selectPropertyUtils';

import { VERTICAL_DISPLAY_TYPE } from '../../constants/PropertiesConstants';

import ConnectedApplications from '../ConnectedApplications';
import ConnectedModuleCard from '../../components/ConnectedModuleCard';

import { TRIGGER_LOCATIONS } from '../../constants/ClickstreamConstants';
import { NoUnderlineAnchor } from '../../styles';

const ApplicationsModule = () => {
  const listingAlias = useSelector((state) => state.properties.currentProperty.listingAlias);
  const applicationsPath = selectPropertyUtils.getPathByType(
    SelectPropertyConstants.APPLICATIONS as keyof typeof SelectPropertyConstants,
    listingAlias,
  );

  const renderCTA = useMemo(() => {
    return (
      <NoUnderlineAnchor href={applicationsPath || ''} target="_self">
        Details
      </NoUnderlineAnchor>
    );
  }, [applicationsPath]);

  return (
    <ConnectedModuleCard
      data-testid="ApplicationsModule"
      title="Applications"
      ctaComponent={renderCTA}
      ctaFontColor="text.subtle"
      ctaFontType="body-sm"
      justifyHeadingContent={'center'}
      isLoading={false}
    >
      <ConnectedApplications
        displayType={VERTICAL_DISPLAY_TYPE.SIMPLE}
        triggerLocation={TRIGGER_LOCATIONS.PROPERTY_OVERVIEW}
      />
    </ConnectedModuleCard>
  );
};

export default ApplicationsModule;
